import Backbone from 'backbone'
import template from './display-header.hbs'
import displayHeaderButtons from './display-header-buttons.hbs'
import PeriodDisplay from 'scoreboard/components/period-display'
import RelativePeriodDisplay from 'scoreboard/components/relative-period-display'
import globals from 'scoreboard/components/globals'
import _ from 'lodash'
import $ from 'jquery'
import BookmarkToggler from 'scoreboard/bookmarks/bookmark-toggler'
import conductor from 'scoreboard/components/conductor'
import spectator from 'scoreboard/components/spectator'
import i18n from 'scoreboard/components/i18n'
import SendTo from './send-to'
import ImportMenu from './import-menu'
import Tooltip from './tooltip'
import CovertButtonTooltips from 'scoreboard/components/covert-button-tooltips'
import briefer from 'scoreboard/briefings/briefer'
import calendars from 'scoreboard/components/calendars'
import permissions from 'scoreboard/components/permissions'
import HistoryInfo from 'scoreboard/components/history-info'
import icon from 'scoreboard/components/icon'
import layoutManager from 'scoreboard/components/layout-manager'
import { isSpectating } from 'scoreboard/components/spectator'
import overviewInfoButton from 'scoreboard/components/overview-info-button.hbs'
import GenericOverviewInfo from 'scoreboard/components/overview-info/generic-overview-info'
import BookmarkOverviewInfo from 'scoreboard/components/overview-info/bookmark-overview-info'
import appDisplay from 'scoreboard/components/app-display'
import user from 'scoreboard/components/user'
import mobile from 'scoreboard/components/mobile'
import mobileHeaderOptions from './mobile-display-header-options.hbs'
var debug = false
import TruncatedTooltip from 'scoreboard/components/truncated-tooltip'
import briefingsLayoutManager from 'scoreboard/briefings/briefings-layout-manager'
import constants from 'scoreboard/components/constants'

var DisplayHeader = Backbone.View.extend({

	tagName: 'header',

	className: 'display-pane-header table-hack-row',

	events: {
		'click .send-to': 'sendTo',
		'click .import-menu': 'importMenu',
		'click a.current': 'disableClick',
		'click .mobile-gear': 'displayHeaderMenu',
		// TODO: Remove when V5 is no longer supported. These will be page
		// sections instead of dialogs
		'click .open-history-info': 'historyInfo',
		'click .audit-tab': 'historyInfo',
		'click .open-overview-info': 'bookmarkOrSourceOverviewInfo',
		'click .info-tab': 'bookmarkOrSourceOverviewInfo',
		'click .fullscreen': 'onClickFullscreen',
		'click .exit-fullscreen': 'onClickExitFullscreen'
	},

	displayHeaderButtons: displayHeaderButtons,

	/**
	 * Initialize this view with a model that has the following properties:
	 *
	 * model - the domain object being viewed in the display pane
	 *
	 * @param {String} [options.heading=model.label]
	 *
	 * @param {Boolean} [options.staticHeading=false] if static, the heading will
	 * not be updated on model.label changes
	 *
	 * @param {Boolean} [options.bookmark=true] true if the bookmark button should be displayed
	 * if the user has permission
	 *
	 * @param {Boolean} [options.guard=true] true if switching periods
	 * should trigger the unsaved guard
	 *
	 * @param {Boolean} [options.periods=false] display periods
	 *
	 * @param {String} [options.subsection] subsection (a.k.a. tab) being viewed
	 */
	initialize: function(options = {}) {
		this.options = _.assign({
			sendToOptions: [],
			importOptions: [],
			bookmark: options.subsection !== 'edit',
			guard: true		//default enables guard when changing periods
		}, options)

		if (!this.options.staticHeading) {
			this.listenTo(this.model, 'change:label', (model) => {
				this.$('.header-container h1').text(this.model.get('label'))
				this.options.bookmark && this.renderBookmarkToggler()
			})
		}

		this.on('clicked:menu', this._menuClickHandler.bind(this))
		this.covertButtonTooltips = new CovertButtonTooltips({ el: this.el })
	},

	/**
	 * Call this method if you want overview info added in the display header
	 */
	setupOverviewInfo: function() {
		this.overviewInfo = () => {
			var model = new this.model.constructor({ id: this.model.id })
			appDisplay.dialog(model.fetch({
				data: {
					relatedItems: true,
					templateInfo: true
				}
			}), () => new GenericOverviewInfo({ model }))
		}
	},

	_menuClickHandler: function(target){
		var openEvent = _.find(this.events, function(e, k){
			var openIndex = k.indexOf('.open-')
			return openIndex > 0 && $(target).hasClass(k.substr(openIndex+1))
		})
		openEvent && this[openEvent]()
	},

	/**
	 * Updates the options, suitable to be called after initial rendering when
	 * a change might require a new set of options to be display.  Callers must
	 * call render to render to the new state.  Merges the old options with
	 * the new passed in options
	 */
	updateOptions: function(options = {}) {
		this.options = _.defaults(options, this.options)
	},

	render: function() {
		let context = this.context()
		Backbone.trigger('pageTitle', context.title)
		this.$el.empty().append(template(context))

		// render display header buttons, default if none is provided
		this.$('.display-header-buttons')
			.append(this.options.displayHeaderButtons ||
				this.displayHeaderButtons())

		if (this.model && this.model.isNew()) {
			this.$('.open-history-info').remove()
		}

		// render tabs
		this.$('.tabs').replaceWith(this.options.tabs)
		// highlight current tab
		this.$('.tabs .tab a').removeClass('current')
		this.$('.tabs .tab.' + this.options.subsection + '-tab a').addClass('current')

		this._renderPeriodDisplay()

		// If the current view doesn't want the mobile gear shown, remove it (eg. admin section)
		// https://github.com/SpiderStrategies/Scoreboard/issues/32168
		if (this.options.mobileGearHidden) {
			this.$('.bookmarks, .mobile-gear').remove()
		}

		// handle bookmarks and briefings and buttons that shouldn't appear on
		// edit tabs if we're currently spectating this view.
		// (spectator.isSpectating() will still be true if this view is being rendered
		// as the result of a drilldown (clicking on widget in a spectated dashboard),
		// so check that too)
		if (isSpectating() && !this.options.drilldown) {
			this.spectate()
		}
		// after calling .specate
		this._renderOverviewButtons()
		// after emptying view need to re-delegate events
		this.delegateEvents(this.events)
		this.secure()

		this.truncatedTooltip = new TruncatedTooltip({ el: this.$('.header-container h1') }).render()

		return this
	},

	_renderOverviewButtons: function() {
		this.options.bookmark && this.renderBookmarkToggler()
		// #23809 move info icon to far left
		var creating = this.model && this.model.isNew()
		var hasOverviewInfo = typeof this.overviewInfo === 'function' && !creating
		if (hasOverviewInfo) {
			this.renderButtons()
		}
	},

	/**
	 * Override this function to render additional buttons
	 */
	renderButtons: function() {
		// #23862 #23809 placement of display header buttons
		// use placeholder instead of relative location for insertion
		this.$('.open-overview-info').replaceWith(overviewInfoButton)
	},

	secure: function() {
		if (this._hideBookmarks()) {
			this.$('.bookmarks').remove()
		}
		if (_.isEmpty(this.options.sendToOptions)) {
			this.$('.send-to').remove()
		}
		if (_.isEmpty(this.options.importOptions)) {
			this.$('.import-menu').remove()
		}
		if (_.isEmpty(this.$('.button-toolbar').children())) {
			this.$('.button-toolbar').remove()
		}
	},

	/**
	 * Views should call this function when the edit tab should be hidden
	 * based on security/permissions.  This method applies any cross-cutting
	 * concerns that override view level permissions:
	 *   - Briefing slide edit tab (which is shared with the header edit tab)
	 *   - Bookmark edit tab
	 *
	 * @param {boolean} isEditable if the current model is editable
	 */
	conditionallyHideEditTab: function(isEditable) {
		const readOnlyBookmarks = conductor.section() === 'bookmarks' && !permissions.bookmarks()
		const hide = readOnlyBookmarks || (!isSpectating() && !isEditable)
		this.$('.edit-tab').toggleClass('is-not-displayed', hide)
	},

	// issue 6952 don't allow clicking on a tab that is already selected
	disableClick: function(e) {
		e.preventDefault()
		e.stopPropagation()
	},

	_renderPeriodDisplay: function() {
		// clean out old period display, if there was one
		this.periodDisplay && this.periodDisplay.remove()

		if (layoutManager.export && briefer.slideControls) {
			let slideInfo = briefer.slideControls.getSlideInfo()
			let label = _.escape(slideInfo.label)
			let slideNumberText = _.escape(slideInfo.slideNumberText)

			this.$('.display-wrapper').before(
				`<div class="export-slide-info">
					${label} <span class="pre-label">${slideNumberText}</span>
				</div>`)
		}

		if (!!this.options.periods == false || !this.$('.tab.period-display').length) {
			briefer.slideControlsPeriodDisplay(false) // Remove period display if it is present
			return
		}

		this.$('.tab.period-display').removeClass('is-not-displayed')

		// if this is a relative slide
		let periodDelta = spectator.getCurrent() && spectator.getCurrent().get('periodDelta')
		let isRelative = briefer.isShowingBriefing() && _.isNumber(periodDelta) ? true : false
		if (isRelative) {
			this.periodDisplay = new RelativePeriodDisplay({
				periodId: briefer.periodId,
				periodDelta: periodDelta,
				guard: this.options.guard,
				mobileResizeOnly: true
			})
		// this is outside briefing books, or a static slide with a fixed periodId
		} else {
			this._createSpecificDatePeriodDisplay()
		}

		if (layoutManager.sharedDashboard) {
			this.periodDisplay.disable()
		}

		this.$('.period-display').empty().append(this.periodDisplay.el)
		this.periodDisplay.render()
		briefer.slideControlsPeriodDisplay(true, briefer.periodId, isRelative, periodDelta)
		this.$el.addClass('has-period-display')
		this.periodDisplay.on('change:period', this.changePeriod.bind(this))
		briefer.syncPeriodDisplays(this.periodDisplay)
	},

	_createSpecificDatePeriodDisplay: function() {
		this.periodDisplay = new PeriodDisplay({
			guard: this.options.guard,
			mobileResizeOnly: true,
			extraTooltipClass: 'display-header-period-tooltip',
			briefingSpecificPeriodId: briefer.isShowingBriefing() ? briefer.periodId : ''
		})
	},

	togglePeriodDisplay: function(show) {
		this.$('.tab.period-display').toggleClass('is-not-displayed', !show)
	},

	changePeriod: function(newPeriodId) {
		var adjustedPeriodId = this.adjustPeriod(newPeriodId)
		this.redrawDisplay(adjustedPeriodId)
	},

	adjustPeriod: function(newPeriodId) {
		if (debug) {
			console.log('newPeriodId: ' + _.result(calendars.periodsById[newPeriodId], 'label'))
			console.log('briefer.periodId -> ' + _.result(calendars.periodsById[briefer.periodId], 'label'))
			console.log('globals.periodId -> ' + _.result(calendars.periodsById[globals.periodId], 'label'))
		}

		// if changing the period for a relative slide
		if (briefer.isShowingBriefing() && _.isNumber(spectator.getCurrent().get('periodDelta'))) {
			// the newPeriodId is the non-adjusted period
			briefer.periodId = newPeriodId
			// briefer.periodId is the unadjusted period ID
			var delta = spectator.getCurrent().get('periodDelta') || 0
			var relativePeriod = calendars.safeRelativePeriod(newPeriodId, delta)
			// note if calendars need to be extended it's possible that
			// relativePeriod will be null
			if (relativePeriod) {
				globals.periodId = relativePeriod.id
			}
		// outside briefing books, or a static slide with a fixed periodId
		} else {
			// #33200 only adjust period if newPeriodId is defined
			// don't want to set it as undefined
			if (newPeriodId) {
				// just change the display, but not the
				globals.periodId = newPeriodId
			}
		}

		if (debug) {
			console.log('briefer.periodId -> ' + _.result(calendars.periodsById[briefer.periodId], 'label'))
			console.log('globals.periodId -> ' + _.result(calendars.periodsById[globals.periodId], 'label'))
		}
		return globals.periodId
	},

	redrawDisplay: function(newPeriodId) {
		// force re-rendering of the screen even though the url is unchanged
		Backbone.history.loadUrl(Backbone.history.fragment)
	},

	_isNonFolder: function() {
		return !this.model || this.model.get('type') !== 'folder'
	},

	/**
	 * Updates the edit tab url when it is being spectated.
	 *
	 * Optionally turns an 'Edit' tab into an 'Edit Slide' tab.
	 * This is done when a view is being displayed in a briefing
	 */
	_updateSpectatedEditTab: function() {
		if (!isSpectating()) return
		let tab = this._updatedSpectatedEditTabUrl()
		if (this._isBriefing()) {
			tab.text(i18n.get('common.edit2', 'briefingBooks.slide'))
		}
	},

	/**
	 * Edit url is updated to reflect the spectated url (bookmark or briefing)
	 * @returns {jQuery} tab element
	 */
	_updatedSpectatedEditTabUrl: function() {
		let tab = this.$('.edit-tab a')
		let url = spectator.buildSpectatedUrl(spectator.getCurrent()) + '/edit'
		tab.attr('href', url)
		return tab
	},

	// Change the 'Overview' (or first appearing tab) tab to read 'View' to be consistent with other
	// slides/bookmarks as well as for when the edit page is shown #28354
	_renameOverviewTab: function() {
		if (this._isBriefing()) {
			this.$('.tabs > .tab:not(.edit-tab):first-child a')
				.text(i18n.get('common.view'))
		}
	},

	_isBriefing: function() {
		return 'briefings' === _.get(spectator.getCurrent(), 'section')
	},

	spectate: function() {
		// Remove the bookmarks and mobile gear icon when displaying a spectated
		// edit tab (within briefing/bookmark)
		// https://github.com/SpiderStrategies/Scoreboard/issues/9827
		if (this.options.subsection === 'edit') {
			this.$('.bookmarks, .mobile-gear').remove()
		}

		const spectating = spectator.getCurrent()
		const briefing = this._isBriefing()

		if (briefing) { // #9691 - No Bookmarks inside briefings
			this.options.bookmark = false
		}

		// #9355 when in the bookmarks section and viewing a briefing folder
		if (spectating && spectating.section === 'bookmarks' &&
				this.model && this.model.get('type') === 'folder') {
			this.$('.tab.edit-tab a')
				.attr('href', spectator.buildSpectatedUrl(spectating) + '/edit')
			this._renameOverviewTab()
		}
		// #12546 when in the briefings section and viewing a folder, switch
		// the edit tab to Edit Slide
		if (briefing && this.model && this.model.get('type') === 'folder') {
			this.$('.tab.edit-tab a')
				.attr('href', spectator.buildSpectatedUrl(spectating) + '/edit')
				.text(i18n.get('briefingBooks.slide.edit.title'))
			this._renameOverviewTab()
		}
		// #9826 hide the edit tab for briefing folders when inside a paused briefing
		if (spectating && briefingsLayoutManager.isPaused() &&
			this.model && this.model.get('type') === 'folder') {
			this.$('.edit-tab').remove()
		}
		// when spectating non-folders
		if (spectating && this._isNonFolder()) {
			// remove any tabs that don't belong
			_.each(this.$('.tab'), tab => {
				tab = $(tab)
				// when editing a briefing, leave the tabs alone
				if (conductor.section(Backbone.history.fragment) === 'briefings'
						&& Backbone.history.fragment.indexOf('slides') == -1) {
					return true
				}

				// the tab that corresponds to the screen being spectated gets
				// to keep its tab.  e.g. the scorecards metrics screen will
				// keep that tab but not the overview tab
				if (spectator.getCurrentUrl() == tab.find('a').attr('href') ||
					tab.hasClass('is-viewable-while-spectating')) {
					return true
				}

				// change the edit tab to edit the bookmark or slide
				if (tab.hasClass('edit-tab')) {
					var current = spectator.getCurrent()
					var section = current.section

					if (section === 'bookmarks') {
						this._updatedSpectatedEditTabUrl()
					}
					if (briefing) {
						// don't allow editing in paused briefings.  See
						// https://github.com/SpiderStrategies/Scoreboard/issues/6118#issuecomment-221991746
						// and also don't show when the user doesn't have permission
						// #20651 check permissions using the briefing organization id
						let orgId = current.briefing.get('organizationId')
						if (briefingsLayoutManager.isPaused() || !permissions.briefings(orgId)) {
							tab.remove()
							return true
						}

						this._updateSpectatedEditTab()
					}
					// show the edit tab
					return true
				}

				this._renameOverviewTab()

				// leave non-edit tabs alone for folders
				if (_.result(this.model, 'attributes.type') === 'folder') {
					return true
				}
				// don't remove the calendar period selector
				if (tab.hasClass('period-display')) {
					return true
				}
				// if we reach here the tab should be removed
				tab.remove()
			})
		}

		this.constructDisplayHeaderMenuHtml()
	},

	renderBookmarkToggler: function() {
		if (this._hideBookmarks()) return

		var insertToggler = () => {
			// #23862 #23809 placement of display header buttons
			// use placeholder instead of relative location for insertion
			this.$('.bookmarks-placeholder').after(this._bookmarkToggler.el)
			this._bookmarkToggler.render()
			this._bookmarkToggler.on('toggle', this.syncBookmarks.bind(this))
			// Re-render the displayHeaderMenu since we've just inserted a new  menu
			// item into the .display-header-buttons
			this.constructDisplayHeaderMenuHtml()
		}

		// If there's already a bookmarkToggler defined here, nix the old one
		// and create a new one. The reason there would be an existing
		// bookmarkToggler is because we're re-rendering things after a change
		// to the model, not a new route, which is why we delay before we create
		// the new bookmarkToggler to make sure the route reflects the
		// current item being displayed
		if (this._bookmarkToggler) {
			process.nextTick(() => {
				// In the initiatives timeline view, when we click on a new timeline node,
				// the model and the url change, but we don't update the state of the bookmark toggler.
				// In order to fix that, this (which is called when the model is updated),
				// redraws the bookmarkToggler based on the current route.
				this._bookmarkToggler.remove()
				this._bookmarkToggler = new BookmarkToggler({
					spectated: spectator.getCurrent(),
					label: this.$('h1').text(),
					uiState: this.options.uiState
					// #23139 don't specify a URL here. It should be pulled
					// from the `spectated` variable
				})
				insertToggler()
			})
		// If there isn't an existing bookmarkToggler, decide which url to use
		// based on what we're viewing
		} else {
			this._bookmarkToggler = new BookmarkToggler({
				spectated: spectator.getCurrent(),
				// the title in the display pane may not be known right away
				// (e.g. on the metrics report)
				label: function() {
					return this.$('h1').text()
				}.bind(this),
				// Distinguish whether we're viewing a bookmark/briefing item or a regular url
				url: spectator.getCurrent() ? spectator.getCurrent().get('url') : Backbone.history.fragment,
				uiState: this.options.uiState
			})
			insertToggler()
		}
	},

	context: function() {
		var context = this.model ? (this.model.attributes ? this.model.attributes : this.model) : {}
		context = _.result(this.options, 'context', _.partial(_.cloneDeep, context))

		const title = _.result(this.options, 'heading') || context.label
		context.title = title
		// the &nbsp; is needed for the metrics report or else the display
		// flickers unnecessarily
		context.heading = _.escape(title) || '&nbsp;'
		context.isEditing = this.options.subsection === 'edit'
		context.staticHeading = this.options.staticHeading
		return context
	},

	sendTo: function(e) {
		var target = $(e.currentTarget)

		this.sendToTooltip = new Tooltip({
			attachTo: target,
			content: new SendTo({
				heading: this.$('h1').text(),
				sendToOptions: this.options.sendToOptions,
				uiState: this.options.uiState
			}),
			placement: 'below',
			arrow: 'right',
			extraClass: 'has-bootslide-menu'
		}).render()
	},

	importMenu: function(e) {
		var target = $(e.currentTarget)
		this.importMenuTooltip = new Tooltip({
			attachTo: target,
			content: new ImportMenu({
				heading: this.$('h1').text(),
				importOptions: this.options.importOptions,
				width: this.options.importWidth,
				uiState: this.options.uiState
			}),
			placement: 'below',
			arrow: 'right',
			extraClass: 'has-bootslide-menu'
		}).render()
	},

	// (Re)create the html for the display header menu based on the display header
	// buttons already rendered
	constructDisplayHeaderMenuHtml: function() {
		var menuItems = ''
		// Gather all non send-to options
		var headerOptions = this.$('.display-header-buttons li:not(.send-to)')
		_.each(headerOptions, function(option) {
			if ($(option).hasClass('bookmarks') && this._hideBookmarks()) {
				return
			}
			let label = _.escape($(option).data('action'))
			if ($(option).hasClass('open-alerts')) {
				let icon = $(option).find('span')
				let alertCountEl = icon.find('.alert-count')
				let count = alertCountEl.text()
				menuItems += `<li class="${$(option).attr('class')}">` +
					`<span class="icon">${icon.html()}</span>` +
					`<span>${label}<span class="alert-bubble">${count}</span></span>` +
					`</li>`
				return
			}
			var icon = $(option).find('span').html()
			menuItems += `<li class="${$(option).attr('class')}">` +
				`<span class="icon">${icon}</span>` +
				`<span>${label}</span>` +
				'</li>'
		}.bind(this))

		_.invoke(this.mobileSendToOptions, 'remove')
		_.invoke(this.mobileImportOptions, 'remove')
		this.mobileSendToOptions = []
		this.mobileImportOptions = []
		menuItems += this.mobileMenuItems(this.options.sendToOptions, 'send-to-option')
		menuItems += this.mobileMenuItems(this.options.importOptions, 'import-option')
		this.headerMenu = '<ul>' + menuItems + '</ul>'
	},

	mobileMenuItems: function(options, extraClass) {
		let menuItems = ''
		_.each(options, (Option, i) => {
			// Save the current screen heading in case it's needed when the option is clicked
			const option = new Option({ model: {heading: this.$('h1').text()} })
			if (extraClass === 'send-to-option') {
				this.mobileSendToOptions.push(option)
			} else {
				this.mobileImportOptions.push(option)
			}
			let optionIcon = `<span class="icon send-to-icon">${icon(option.icon)}</span>`
			let label = option.mobileLabel ? option.mobileLabel : option.label
			let optionLabel = `<span>${_.escape(i18n.get(label))}</span>`
			menuItems += `<li class="${extraClass}" data-index="${i}">${optionIcon}${optionLabel}</span></li>`
		})
		return menuItems
	},

	// Display header menu activated by clicking the gear button. Menu items created
	// in renderDisplayHeaderMenu() are attached to their respective functions here
	displayHeaderMenu: function() {
		this.constructDisplayHeaderMenuHtml() // Update menu if needed

		// If we're within the mobile menu threshold, use a dialog to display the
		// header menu, but if not, use a tooltip.
		if (mobile.isMobileOrientation()) {
			this.mobileMenu = appDisplay.dialog(mobileHeaderOptions({
				title: i18n.get('common.options'),
				menu: this.headerMenu
			}))
		} else {
			this.mobileMenu = new Tooltip({
				attachTo: this.$('.mobile-gear'),
				content: this.headerMenu,
				placement: 'below',
				arrow: 'right',
				extraClass: 'display-header-menu mobile-display-header-menu'
			}).render()
		}

		// Hook up bookmark toggler
		this._mobileBookmarkToggler = new BookmarkToggler({
			el: this.mobileMenu.$('.bookmarks'),
			spectated: spectator.getCurrent(),
			label: function() {
				return this.$('h1').text()
			}.bind(this)
		}).render()
		this._mobileBookmarkToggler.on('toggle', this.syncBookmarks.bind(this))

		// When a mobile menu item is clicked, fire an event so that buttons
		// other than those created in this view can execute their functions
		// (ex. scorecards-overview-info). If the item clicked is a send-to option,
		// execute the appropriate sendTo function.
		this.mobileMenu.$('li').on('click', e => {
			let item = $(e.currentTarget)
			this.trigger('clicked:menu', item)
			if (item.hasClass('send-to-option')) {
				const {index} = item.data()
				this.mobileSendToOptions[index].send()
			}

			if (item.hasClass('import-option')) {
				const {index} = item.data()
				this.mobileImportOptions[index].openImport()
			}

			// Don't go as far as to dismiss the mobile menu tooltip if we're dealing with the
			// bookmarks option. When marking the current view, the tooltip will stay around
			// instead of disappearing immediately, allowing the user to see the star icon
			// change as confirmation. When the bookmarks option is chosen to unmark the view
			// as a bookmark, a dialog is displayed which dismisses the tooltip but isn't distracting.
			if (item.hasClass('bookmarks')) {
				return
			}

			if (item.hasClass('import-initiative-status')) {
				this.trigger('importInitiativeStatus')
				return
			}

			if (!mobile.isMobileOrientation()) {
				this.mobileMenu.remove()
			}
		})
	},

	_hideBookmarks: function() {
		return !permissions.bookmarks() || (!!this.options.bookmark == false) || user.isStrictViewer()
	},

	// Ensure the mobile and regular bookmark toggler stay in sync when either is changed
	syncBookmarks: function(bookmarked) {
		this._bookmarkToggler && this._bookmarkToggler.toggleBookmark(bookmarked)
		this._mobileBookmarkToggler && this._mobileBookmarkToggler.toggleBookmark(bookmarked)
	},

	historyInfo: function() {
		HistoryInfo.display(this.model, this.$('h1').text())
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.periodDisplay, this._bookmarkToggler,
			this._mobileBookmarkToggler, this.mobileMenu, this.sendToTooltip,
			this.mobileMenu, this.mobileSendToOptions, this.truncatedTooltip,
			this.importMenuTooltip, this.mobileImportOptions,
			this.covertButtonTooltips],
			'remove')
	},

	/**
	 * #32703 when the overview button on a bookmark, then we want to show information
	 * about the bookmark rather than the item that is bookmarked
	 */
	bookmarkOrSourceOverviewInfo() {
		if (conductor.section() === 'bookmarks') {
			// We are on a bookmark. Show bookmark information
			var bookmark = spectator.getCurrent()
			// The thing that is bookmarked
			let spectated = _.get(this.model, 'attributes')
			appDisplay.dialog(new BookmarkOverviewInfo({ bookmark, spectated }))
		} else {
			// Not a bookmark; show info for the actual item
			this.overviewInfo()
		}
	},

	/*
	 * Toggles fullscreen layout and updates the fullscreen button state.
	 */
	onClickToggleFullscreen: function (isFullscreen) {
		const layout = isFullscreen ? constants.LAYOUT_FULLSCREEN : constants.LAYOUT_STANDARD
		layoutManager.changeLayout(layout)
		this.toggleFullscreenButton(isFullscreen)
	},

	/*
	 * Changes the layout so the display is fullscreen and side and top
	 * navigation is hidden.
	 */
	onClickFullscreen: function () {
		// Issue #58101
		this.onClickToggleFullscreen(true)
	},

	/*
	 * Returns to the default layout.
	 */
	onClickExitFullscreen: function () {
		this.onClickToggleFullscreen(false)
	},

	/*
	* Maintains active state when fullscreen
	* Fixes #58101
	*/
	toggleFullscreenButton: function (isFullscreen) {
		this.$('.exit-fullscreen').toggleClass('is-selected', isFullscreen)
	}
})

export default DisplayHeader

DisplayHeader.__filename__ = 'components/display-header.js'
